import { LocationsDTO } from 'models'

export const removeDuplicateCities = (
    cities: LocationsDTO[]
): LocationsDTO[] => {
    const seen = new Set()
    return cities.filter(city => {
        const keyValue = city['codigoTomDetran']
        if (seen.has(keyValue)) {
            return false
        }
        seen.add(keyValue)
        return true
    })
}
